/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ProjectWindowInfo } from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ProjectWindowClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags ProjectWindow
   * @summary Получить все окна проекта
   * @request GET:/project/ProjectWindow/{projectId}/windows
   * @secure
   */
  projectWindowGetProjectWindows = (projectId: string, params: RequestParams = {}) =>
    this.http.request<ProjectWindowInfo[], any>({
      path: `/project/ProjectWindow/${projectId}/windows`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectWindow
   * @summary Получить окно проекта по идентификатору
   * @request GET:/project/ProjectWindow/{projectWindowId}
   * @secure
   */
  projectWindowGetProjectWindowById = (projectWindowId: string, params: RequestParams = {}) =>
    this.http.request<ProjectWindowInfo, any>({
      path: `/project/ProjectWindow/${projectWindowId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectWindow
   * @summary Получить настройки окна проекта по идентификатору
   * @request GET:/project/ProjectWindow/{projectWindowId}/config
   * @secure
   */
  projectWindowGetProjectWindowConfigById = (projectWindowId: string, params: RequestParams = {}) =>
    this.http.request<string, any>({
      path: `/project/ProjectWindow/${projectWindowId}/config`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectWindow
   * @summary Добавить окно проекта
   * @request POST:/project/ProjectWindow
   * @secure
   */
  projectWindowAddProjectWindow = (data: ProjectWindowInfo, params: RequestParams = {}) =>
    this.http.request<string, any>({
      path: `/project/ProjectWindow`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectWindow
   * @summary Изменить существующее окно проекта
   * @request PUT:/project/ProjectWindow
   * @secure
   */
  projectWindowUpdateProjectWindow = (data: ProjectWindowInfo, params: RequestParams = {}) =>
    this.http.request<boolean, any>({
      path: `/project/ProjectWindow`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectWindow
   * @summary Удалить существующее окно проекта
   * @request DELETE:/project/ProjectWindow
   * @secure
   */
  projectWindowDeleteProject = (
    query: {
      /**
       * Идентификатор окна проекта
       * @format uuid
       */
      projectWindowId: string
    },
    params: RequestParams = {},
  ) =>
    this.http.request<boolean, any>({
      path: `/project/ProjectWindow`,
      method: 'DELETE',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectWindow
   * @summary Изменить настройки окна проекта
   * @request PUT:/project/ProjectWindow/{projectWindowId}/updateConfig
   * @secure
   */
  projectWindowUpdateProjectWindowConfig = (
    projectWindowId: string,
    data: string,
    params: RequestParams = {},
  ) =>
    this.http.request<boolean, any>({
      path: `/project/ProjectWindow/${projectWindowId}/updateConfig`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectWindow
   * @summary Получить список типов окон проекта
   * @request GET:/project/ProjectWindow/TabTypes
   * @secure
   */
  projectWindowGetTabTypes = (params: RequestParams = {}) =>
    this.http.request<Record<string, string>, any>({
      path: `/project/ProjectWindow/TabTypes`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    })
}
